module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-sans",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "ma-0": "",
      "pa-0": "",
      "fluid": ""
    }
  }, [_c('sub-tabs', {
    attrs: {
      "nomeSessao": "Pedidos",
      "tabs": _vm.tabs
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "offset-md6": "",
      "md5": ""
    }
  }, [_c('v-text-field', {
    staticClass: "searchInput",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "label": "Pesquisar pedidos",
      "append-icon": "search"
    },
    model: {
      value: (_vm.searchOrders),
      callback: function($$v) {
        _vm.searchOrders = $$v
      },
      expression: "searchOrders"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ab9ce3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/pedidos/index.vue
// module id = 747
// module chunks = 25